import { Text, useToast } from '@chakra-ui/react'
import { useEffect, useMemo, useRef, useState } from 'react'
// import { errorHandle } from '../../api/api'
import { getAllContracts } from '../../classes/Contract'
import { useSearchQueryContext } from '../../context/searchQueryContext'
import { useUserContext } from '../../context/userContext'
import { ExportToolsPanel, Table, TextDateFormat } from '../shared'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'

const TableAllContracts = () => {
    const toast = useToast()
    const { userData } = useUserContext()
    const [data, setData] = useState(null)
    const { query } = useSearchQueryContext()

    const columns = useMemo(() => [
        {
            Header: '#',
            Cell: ({ row }) => (<Text>{row.index + 1}</Text>)
        },
        {
            Header: 'ผู้ทำสัญญา',
            Cell: ({ row: { original } }) => (<Text>{`${original.first_name} ${original.last_name}`}</Text>)
        },
        {
            Header: 'หน่วยงาน',
            accessor: 'office_name',
        },
        {
            Header: 'วันที่ทำสัญญา',
            accessor: 'contract_date',
            Cell: ({ value }) => <TextDateFormat value={value} datetime={false} />
        },
        {
            Header: 'เลขที่สัญญา',
            accessor: 'contract_no',
        },
    ], [])

    const loadData = useRef()
    loadData.current = async () => {
        if (query) {
            await getAllContracts(query, userData.token)
                .then(res => {
                    // console.log('load data')
                    setData(res)
                })
                .catch(error => {
                    // console.log('error')
                    // console.log(errorHandle(error))
                    toast(toastVal({
                        title: "การดึงข้อมูล ไม่สำเร็จ",
                        description: toastErrDesc(error),
                        status: "error",
                    }))
                })
        }
    }

    useEffect(() => {
        loadData.current()
    }, [query])

    const exportData = useMemo(() => {
        return data && {
            excel: {
                data: data.map((r,index)=>r.export(index)),
                fileName: "รายการทำสัญญา"
            }
        }
    }, [data])

    return (
        <>
            {data && <ExportToolsPanel options={exportData} />}
            {data && <Table columns={columns} data={data} />}
        </>
    )

}

export default TableAllContracts